// Shared colors from the approved Figma reference. Keep semantic status and brand colors separate.
const palette = {
  primary: '#5F63F2',
  primaryHover: '#4347D9',
  primarySoft: '#F1F2FF',
  primaryBorder: '#E5E6FF',
  secondary: '#8FD889',
  secondaryHover: '#76C96E',
  secondaryText: '#235B2A',
  heading: '#272B41',
  text: '#5A5F7D',
  muted: '#868EAE',
  placeholder: '#ADB4D2',
  border: '#E3E6EF',
  divider: '#F1F2F6',
  canvas: '#F4F5F7',
  surface: '#FFFFFF',
};
export default palette;
